// Códigos de sistema repetem `id` para o mesmo tipo de equipamento (ex.: -14 é "Omissão"
// no grupo 8 e "Serv. Externo" no grupo 14). Assim como no backend, um código só é
// identificado de forma única por `id + id_equip + id_group + code_type`.

// Monta a chave única do código: `id:id_equip:id_group:code_type` (ex.: "-14:21:14:2").
// O separador `:` evita confusão com o sinal de ids negativos.
export const buildCodeKey = ({
  id, equipType, codeGroup, codeType,
}) => `${id}:${equipType}:${codeGroup}:${codeType}`;

export const buildCodeKeyFromCode = code => buildCodeKey({
  id: code.id,
  equipType: code.id_equip,
  codeGroup: code.id_group,
  codeType: code.code_type,
});

// Map chave única → código.
export const toCodesMapByKey = (codes = []) => (codes || []).reduce((acc, code) => {
  const key = buildCodeKeyFromCode(code);
  if (!acc[key]) acc[key] = code;
  return acc;
}, {});

// Resolve o código de um status de equipamento
// (`id_code`, `equip_type`, `id_code_group`, `code_type`).
export const getCodeFromStatus = (codesByKey, status) => (status ? codesByKey?.[buildCodeKey({
  id: status.id_code,
  equipType: status.equip_type,
  codeGroup: status.id_code_group,
  codeType: status.code_type,
})] : undefined);

// Resolve o código de um item de origem/destino
// (`code_id`, `equip_type_id`, `code_group_id`, `code_type_id`).
export const getCodeFromOrigin = (codesByKey, item) => (item ? codesByKey?.[buildCodeKey({
  id: item.code_id,
  equipType: item.equip_type_id,
  codeGroup: item.code_group_id,
  codeType: item.code_type_id,
})] : undefined);

// Busca o código pelos campos da chave única que estiverem disponíveis
// (os `undefined` são ignorados).
export const findCode = (codes, {
  id, equipType, codeGroup, codeType,
}) => (codes || []).find(code => code.id === id
  && (equipType === undefined || code.id_equip === equipType)
  && (codeGroup === undefined || code.id_group === codeGroup)
  && (codeType === undefined || code.code_type === codeType));
